module.exports = __webpack_public_path__ + "img/uk.39195acc.svg";